module.exports = __webpack_public_path__ + "img/3.1d1219e1.jpg";